import RecategorizacionView from "./RecategorizacionView";
export default RecategorizacionView;